import axios from 'axios'

const DashboardService = {
  async getStatistics (params = {}) {
    return axios.get('po/dashboard', { params })
  }
}

export default DashboardService
